import React from 'react';
import CustomProgress from '../custom-progress-tooltip';
import Hint from './hint';

const ProgressWithHint = ({func}: {func: any}) => {
  return (
    <>
      <Hint />
      <CustomProgress className="lg pb_20" time={2000} func={func} />
    </>
  );
};

export default ProgressWithHint;
